import React from "react";
import Layout from "../components/Layout";
import Map from "../components/Map";
import Sponsers from "../components/Sponsors";

const science = [
  {
    name: "ECO-LUTION",
    description:
      "Dive into ECO-LUTION and design a greener future! Unleash your creativity to solve sustainability challenges. Bring real-world solutions to make a difference. Join us in crafting a sustainable Earth.",
    image: require("./../assets/modules/ecolution.png"),
  },
  {
    name: "ECO-LUTION",
    description:
      "Dive into ECO-LUTION and design a greener future! Unleash your creativity to solve sustainability challenges. Bring real-world solutions to make a difference. Join us in crafting a sustainable Earth.",
    image: require("./../assets/modules/ecolution.png"),
  },
  {
    name: "ECO-LUTION",
    description:
      "Dive into ECO-LUTION and design a greener future! Unleash your creativity to solve sustainability challenges. Bring real-world solutions to make a difference. Join us in crafting a sustainable Earth.",
    image: require("./../assets/modules/ecolution.png"),
  },
  {
    name: "ECO-LUTION",
    description:
      "Dive into ECO-LUTION and design a greener future! Unleash your creativity to solve sustainability challenges. Bring real-world solutions to make a difference. Join us in crafting a sustainable Earth.",
    image: require("./../assets/modules/ecolution.png"),
  },
  {
    name: "ECO-LUTION",
    description:
      "Dive into ECO-LUTION and design a greener future! Unleash your creativity to solve sustainability challenges. Bring real-world solutions to make a difference. Join us in crafting a sustainable Earth.",
    image: require("./../assets/modules/ecolution.png"),
  },
  {
    name: "ECO-LUTION",
    description:
      "Dive into ECO-LUTION and design a greener future! Unleash your creativity to solve sustainability challenges. Bring real-world solutions to make a difference. Join us in crafting a sustainable Earth.",
    image: require("./../assets/modules/ecolution.png"),
  },
  {
    name: "ECO-LUTION",
    description:
      "Dive into ECO-LUTION and design a greener future! Unleash your creativity to solve sustainability challenges. Bring real-world solutions to make a difference. Join us in crafting a sustainable Earth.",
    image: require("./../assets/modules/ecolution.png"),
  },
];

const hackathon = [
  {
    name: "ECO-LUTION",
    description:
      "Dive into ECO-LUTION and design a greener future! Unleash your creativity to solve sustainability challenges. Bring real-world solutions to make a difference. Join us in crafting a sustainable Earth.",
    image: require("./../assets/modules/ecolution.png"),
  },
  {
    name: "ECO-LUTION",
    description:
      "Dive into ECO-LUTION and design a greener future! Unleash your creativity to solve sustainability challenges. Bring real-world solutions to make a difference. Join us in crafting a sustainable Earth.",
    image: require("./../assets/modules/ecolution.png"),
  },
];

const Modules = () => {
  return (
    <Layout>
      <section>
        <div class="slider-area">
          <div
            class="single-slider hero-overlay slider-height2 slider-bg2 d-flex align-items-center "
            style={{
              background: `url(${require("./../assets/modules/download.jpeg")})`,
              backgroundSize: "inherit",
            }}
          >
            <div class="container">
              <div class="row justify-content-center ">
                <div class="col-xxl-12">
                  <div class="hero-caption hero-caption2">
                    <h2>Modules</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="count-down-area top-padding container">
        <div
          style={{
            margin: "auto",
          }}
        >
          <div className="modles-container">
            <center>
              <h1 className="text-light modules-header">Science Olympiad</h1>
              <br />
              <br />
            </center>
            {Array.from({ length: science.length }, (_, index) => {
              const module = science[index];
              return (
                <>
                  <div className="row w-100 m-auto">
                    <div
                      className="col-12 col-md-5"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <img src={module.image} alt="" className="module-icon" />
                    </div>
                    <div
                      className="col-12 col-md-7"
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <div class="card bg-transparent border-0">
                        <div class="card-body ">
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span
                              class="text-light"
                              style={{
                                fontSize: "80px",
                                padding: "0",
                                margin: "0",
                              }}
                            >
                              {(index + 1 + "").padStart(2, "0")}
                            </span>
                            <span class="text-light module-name">
                              {module.name}
                            </span>
                          </div>

                          <p class="card-text text-light">
                            {module.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="text-light m-auto w-75 mt-5 mb-5" />
                  <br />
                </>
              );
            })}
          </div>
          <div className="modules-container">
            <center>
              <h1 className="text-light modules-header">TechFusion Odyssey</h1>
              <br />
              <br />
            </center>
            {Array.from({ length: hackathon.length }, (_, index) => {
              const module = hackathon[index];
              return (
                <>
                  <div className="row w-100 m-auto">
                    <div
                      className="col-12 col-md-5"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <img src={module.image} alt="" className="module-icon" />
                    </div>
                    <div
                      className="col-12 col-md-7"
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <div class="card bg-transparent border-0">
                        <div class="card-body ">
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span
                              class="text-light"
                              style={{
                                fontSize: "80px",
                                padding: "0",
                                margin: "0",
                              }}
                            >
                              {(index + 1 + "").padStart(2, "0")}
                            </span>
                            <span class="text-light module-name">
                              {module.name}
                            </span>
                          </div>

                          <p class="card-text text-light">
                            {module.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr className="text-light m-auto w-75 mt-5 mb-5" />
                  <br />
                </>
              );
            })}
          </div>
        </div>
      </section>
      <Map />
    </Layout>
  );
};

export default Modules;
